module.exports = __webpack_public_path__ + "img/portfolio-07-481x325.ec19ded4.jpg";